import React from "react";
import moment from "moment";
import history from "@irati/utils/history";
import Flex from "@irati/ui/src/Flex";
import ProfilePicture from "@irati/ui/src/ProfilePicture";
import { H4 } from "@irati/ui/src/Headings";
import Pill from "@irati/ui/src/Pill";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Button from "@irati/ui/src/Button";
import { AdminBlock, Email, FlexGrow } from "./styled";
var AdminSummary = function (props) {
    var user = props.user, formatMessage = props.formatMessage;
    var pillText = formatMessage({ id: "admin.dashboard.adminSummary.activeFrom" }) + ": " + moment(user.metadata.createdAt).format("DD.MM.YYYY");
    return (React.createElement(AdminBlock, { small: true },
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", height: "100%" },
            React.createElement(ProfilePicture, { large: true, user: user, marginRight: true }),
            React.createElement(FlexGrow, { maxWidth: "210px", direction: "column", justifyContent: "space-between", height: "100%" },
                React.createElement(H4, { bold: true, margin: "10px 0 0" },
                    user.firstName,
                    " ",
                    user.lastName),
                React.createElement(Email, null, user.email)),
            React.createElement(Flex, { direction: "column", justifyContent: "space-between", height: "100%" },
                React.createElement(Pill, { text: pillText }),
                React.createElement(Button, { small: true, onClick: function () { return history.push("/account/profile"); } },
                    React.createElement(Icon, { icon: IconTypes.edit, small: true, marginRight: true }),
                    React.createElement(FormattedMessage, { id: "admin.dashboard.adminSummary.editProfile" }))))));
};
export default injectIntl(AdminSummary);
